<template>
  <article class="tes-article tes-article_empty"
           itemscope itemtype="http://schema.org/Article">

    <header class="tes-article__header">

      <h1 class="tes-article__header-title">&nbsp;</h1>

      <ul class="tes-article__tags-container">
        <!-- li :class="['tes-article__tag', `tes-article__tag_color-${num}`]" v-for="num in [1,2]" v-bind:key="num">
          <a href="!#" class="tes-article__tag-link">&nbsp;</a>
        </li -->
      </ul>

      <div class="tes-article__metrics">
        <span>&nbsp;</span>
        <span class="tes-article__metrics-item tes-article__metrics-item_comments">
          <a href="#comments"><span class="tes-article__metrics-icon-wrapper">
            <CommentBarsIcon class="tes-article__metrics-icon" style="max-width:24px;"/>
            <!-- font-awesome-icon icon="fa-solid fa-comment-dots" class="tes-article__metrics-icon" style="max-width:24px;"/-->
          </span> <span title="количество комментарие">&nbsp;</span></a>
        </span>
        <span class="tes-article__metrics-item tes-article__metrics-item_views">
          <span class="tes-article__metrics-icon-wrapper">
            <EyeIcon class="tes-article__metrics-icon" style="max-width:24px;"/>
            <!-- font-awesome-icon icon="fa-solid fa-eye" class="tes-article__metrics-icon" style="max-width:24px;" /-->
          </span> &nbsp;
        </span>
        <span class="tes-article__metrics-item tes-article__metrics-item_age-rating">
          <span class="tes-article__metrics-icon-wrapper"
          ><Rating12PlusIcon class="tes-article__metrics-icon" style="max-width:28px;"/></span>
        </span>
      </div>

    </header>

    <figure class="tes-picture__container tes-picture__container_loading"></figure>

    <div class="tes-article__introduction">
      <div class="tes-article__introduction-icon-wrapper tes-article__introduction-icon-wrapper_style" >
        <!-- font-awesome-icon icon="fa-solid fa-comment-dots" class="tes-article__introduction-icon"/ -->
      </div>
      <p class="tes-article__dates">
        <span class="tes-article__date-published">Опубликовано: &nbsp;</span>
        <span class="tes-article__date-updated">Обновлено: &nbsp;</span>
      </p>
      <div class="tes-article__introduction-content">&nbsp;</div>
    </div>

    <nav class="tes-article__theses">
      <h2 class="tes-article__theses-list-header">Содержание:</h2>
      <ul class="tes-article__theses-list">
        <li class="tes-article__theses-list-item" v-for="num in [1,2,3,4,5]" v-bind:key="num">
          <span class="tes-article__thesis-link">&nbsp;</span>
        </li>
      </ul>
    </nav>

    <div class="tes-article__body">
      <p class="tes-article__paragraph" v-for="num in [1,2,3,4,5,6,7,8,9,10]" v-bind:key="num">
        <span v-for="n in Array.from({length: Math.floor(2 + Math.random() * 10)})">&nbsp;</span>
      </p>
    </div>

    <div class="tes-article__footer">
      <p class="tes-article__footer-author">Автор: <span>&nbsp;</span></p>
      <p class="tes-article__footer-source">Источник: <span>&nbsp;</span></p>
    </div>

  </article>
</template>

<script lang="ts">
import CommentBarsIcon from '~/assets/icons/comment_bars.svg'
import EyeIcon from '~/assets/icons/eye.svg'
import Rating12PlusIcon from '~/assets/icons/age-ratings/12-plus.svg'
export default {
  name: 'PostEmptyView',
  components: {CommentBarsIcon, EyeIcon, Rating12PlusIcon}
}
</script>

<style scoped>

</style>
